import { NgIf, AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Cart } from '@next/core-lib/cart';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Component({
  selector: 'app-total-ordered-weight',
  templateUrl: './total-ordered-weight.component.html',
  imports: [NgIf, AsyncPipe, AgrI18nSharedModule],
})
export class TotalOrderedWeightComponent {
  private readonly cartSubject: BehaviorSubject<Cart> = new BehaviorSubject<Cart>(null);

  public readonly shouldShowTotalOrderedWeight$: Observable<boolean> = this.cartSubject.pipe(
    map((cart) => cart.lines.some((line) => line.orderingInformation?.orderUnit === 'KGD')),
  );

  public readonly totalOrderedWeight$: Observable<number> = this.cartSubject.pipe(
    map((cart) => cart.lines.reduce((acc, line) => acc + line.quantity * line.skuUnitGrossWeight, 0)),
  );

  @Input({ required: true })
  public set cart(v: Cart) {
    this.cartSubject.next(v);
  }
}
